
import { SubDomain } from "../../SubDomain.js";
import EmployeePreferences from "./EmployeePreferences.js";
import EmployeePreferencesMap from "./EmployeePreferencesMap.js";

export default class EmployeePreferencesDomain extends SubDomain {
  constructor(domain, storage) {
    super(domain, EmployeePreferences.MODEL_NAME);
    this.storage = storage.EmployeePreferencesStorage_State;
  }

  list() {
    return this.storage.list;
  }

  findByCompany(companyId) {
    var prefs = this.list();
    var found = new EmployeePreferencesMap(this.domain);
    for (var i = 0; i < prefs.length; i++) {
      var item = prefs[i];
      var employeePrefs = new EmployeePreferences(this.domain, item);
      if (employeePrefs.company().id() === companyId) {
        found.add(employeePrefs);
      }
    }
    return found;
  }
  
  findById(employeeId) {
    var prefs = this.list();
    for (var i = 0; i < prefs.length; i++) {
      var item = prefs[i];
      var employeePrefs = new EmployeePreferences(this.domain, item);
      if (employeePrefs.id() === employeeId) {
        return employeePrefs;
      }
    }
    return new EmployeePreferences(this.domain);
  }
  
  findByUser(user) {
    return this.findByUserId(user.id());
  }
  
}